export enum PermissionConstants {
  AUTHENTICATOR = "Authenticator",
  INVENTORY = "Inventory",
  MILESTONES = "Milestones",
}
